<template>
  <div class="header_box">
    <div  class="login">
      <span
        class="login_btn"
        @click="logInHander(1)"
        v-html="$store.state.logName"
        >登录</span
      >
    </div>

    <!--    <div class="login_code">-->
    <!--      <span class="welcome" v-html="$store.state.serverImages.logoText"></span>-->
    <!--      <span-->
    <!--        class="login_btn"-->
    <!--        @click="logInHander(1)"-->
    <!--        v-html="$store.state.logName"-->
    <!--      >登录</span>-->
    <!--      <div class="code">-->
    <!--        <span v-if="this.$store.state.needWeChatCode"-->
    <!--        ><img src="../../assets/images/banner/follow.png" alt="" />关注我们-->
    <!--          <img-->
    <!--            class="code_img"-->
    <!--            :src="this.$store.state.serverImages.wxImages"-->
    <!--          />-->
    <!--        </span>-->
    <!--        <span v-if="this.$store.state.needAppCode"-->
    <!--        ><img-->
    <!--          src="../../assets/images/banner/download.png"-->
    <!--          alt=""/>手机app下载<img-->
    <!--          class="code_img"-->
    <!--          :src="this.$store.state.serverImages.appImages"-->
    <!--        /></span>-->
    <!--        <a href="javascript:void(0)" @click="setHomepage(this)">-->
    <!--          <span-->
    <!--          ><img-->
    <!--            src="../../assets/images/banner/homepage.png"-->
    <!--            alt=""-->
    <!--          />设为首页</span-->
    <!--          >-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="header">
      <div class="header_img" style="margin-left:20px; cursor:pointer" @click="backshouye()">
        <img :src="this.$store.state.serverImages.logoImage" />
        <div>
          <!-- <svg-icon icon-class="logo" /> -->
          <img :src="this.$store.state.serverImages.titleImages" />
        </div>
      </div>
      <div class="header_nav">
        <ul v-html="header"></ul>
      </div>
      <div class="header_weather">
        <!-- <div class="header_weather_city">
          <p>{{ weather.city }}</p>
          <p>空气质量：{{ weather.air }}</p>
        </div> -->
        <div class="header_weather_img">
          <img :src="weather.img" alt="" />
        </div>
        <div class="header_weather_content">
          <p>{{ weather.week }}</p>
          <p>{{ weather.temperature }}</p>
          <p>{{ weather.cond }}</p>
        </div>
      </div>
     
    </div>

    <el-dialog
      @keyup.enter.native="logInHander(3)"
      width="400px"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      :title="dialog.title"
      :visible.sync="dialog.dialogVisible"
    >
      <div v-if="dialog.title === '登录'">
        <el-input
          placeHolder="请输入账号"
          v-model="dialog.name"
          clearable
        ></el-input>
        <el-input
          placeHolder="请输入密码"
          v-model="dialog.passWord"
          show-password
          clearable
        ></el-input>
      </div>
      <div v-else>是否退出?</div>
      <span slot="footer" class="dialog-footer">
        <button
          @click="logInHander(3)"
          class="el-button el-button--primary el-button--small"
        >
          确 定
        </button>
        <button
          @click="logInHander(2)"
          class="el-button el-button--danger el-button--small"
        >
          取 消
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import stepInWetland from "@/components/stepInWetland/stepInWetland";
export default {
  data() {
    return {
      bannerNavContainer1: "",
      bannerNavContainer2: "",
      bannerNavContainer3: "",
      bannerNavContainer4: "",
      bannerNavContainer5: "",
      dialog: {
        title: "",
        dialogVisible: false,
        name: "",
        passWord: ""
      },
      targetList: [],
      header: "",
      weather: {
        city: "",
        air: "",
        img: "",
        week: "",
        temperature: "",
        cond: ""
      }
    };
  },
  components: {
    stepInWetland
  },
  created() {
  },
  methods: {
    //路由跳转
    // bannerNavClick(currentRole, key) {
    //   $(".header_nav li").removeClass("active");
    //   this.$router.push({ path: currentRole, query: { value: key } });
    //   $(".banner_nav_B .banner_nav_container span").removeClass("active");
    //   $(".bannerNavContainer" + key).addClass("active");
    // },
    // 系统头部轮播展示数据
    gettargetList() {
      this.targetList = [];
      this.axios
        .get(
          this.$store.state.Url4+"naturalFactors/queryNewMonitorEle",
          {
            params: { isShow: 1, soId:  this.$store.state.Soid}
          }
        )
        .then(data => {
          data = data.data.data;
          if (data.airList.length > 0) {
            this.targetList.push({ name: "空气", level: "" });
            data.airList.forEach(item => {
              if (item.annotation.length > 0) {
                this.targetList.push({
                  name: item.name,
                  level: item.annotation
                });
              } else {
                this.targetList.push({ name: item.name, level: item.level });
              }
            });
          }
          if (data.soilList.length > 0) {
            this.targetList.push({ name: "土壤", level: "" });
            data.soilList.forEach(item => {
              if (item.annotation.length > 0) {
                this.targetList.push({ name: item.name, level: annotation });
              } else {
                this.targetList.push({ name: item.name, level: level });
              }
            });
          }
          console.log(data.waterList);
          if (data.waterList.length > 0) {
            this.targetList.push({ name: "水质", level: "" });
            data.waterList.forEach(item => {
              if (item.annotation.length > 0) {
                this.targetList.push({
                  name: item.name,
                  level: item.annotation
                });
              } else {
                this.targetList.push({ name: item.name, level: item.level });
              }
            });
          }
          if (data.weatherList.length > 0) {
            this.targetList.push({ name: "气象", level: "" });
            data.weatherList.forEach(item => {
              if (item.annotation.length > 0) {
                this.targetList.push({
                  name: item.name,
                  level: item.annotation
                });
              } else {
                this.targetList.push({ name: item.name, level: item.level });
              }
            });
          }
          console.log(this.targetList);
        });
    },
    //设置首页
    setHomepage(obj) {
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage(window.location);
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将 [signed.applets.codebase_principal_support]的值设置为'true',双击即可。"
            );
          }
          var prefs = Components.classes[
            "@mozilla.org/preferences-service;1"
          ].getService(Components.interfaces.nsIPrefBranch);
          prefs.setCharPref("browser.startup.homepage", window.location);
        } else {
          alert(
            "您的浏览器不支持，请按照下面步骤操作：\n1.打开浏览器设置。\n2.点击设置网页。\n3.输入：" +
              window.location +
              "点击确定。"
          );
        }
      }
    },
    backshouye(){
      // 跳转到首页
      this.$router.push({
           path: "/",
      })
    },
    getMenuData() {
      let status = 0;
      if (this.$store.state.logName == "登录") {
        status = 0;
      } else {
        status = 1;
      }
      this.axios({
        method: "post",
        url:
          this.$store.state.Url7 + "SysFrontEndMenu/querySysFrontEndMenuList",
        data: {
          soId: this.$store.state.Soid,
          status: status,
          type: 1
        }
      })
        .then(data => {
          sessionStorage.setItem(
            "menuItemData",
            JSON.stringify(data.data.data)
          );
          this.$store.state.getMenuItemData = data.data.data;
          this.setMenu();
          this.dialog.dialogVisible = false;
          // this.judgeLog();
          // 控制登录按钮
          this.$store.state.isshowloginbtn =
            data.data.data[0].remark == "false" ? false : true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 登录事件
    logInHander(type) {
      if (type === 1) {
        this.dialog.dialogVisible = true;
        if (this.$store.state.logName === "登录") {
          this.dialog.title = "登录";
        } else {
          this.dialog.title = "退出";
        }
      } else if (type === 2) {
        this.dialog.dialogVisible = false;
      } else if (type === 3) {
        if (this.dialog.title === "登录") {
          let uName = this.dialog.name.trim();
          let uPwd = this.dialog.passWord.trim();
          if (uName.length === 0 || uPwd.length === 0) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: "用户名或密码不能为空！",
              type: "warning"
            });
          } else {
            let data = {
              suLoginname: uName,
              suPwd: uPwd,
              soId: this.$store.state.Soid
            };
            this.axios({
              method: "post",
              url: this.$store.state.Url7 + "login",
              data: data,
              headers: {
                "Content-Type": "application/json"
              },
              transformRequest: [
                function() {
                  // 对 data 进行任意转换处理
                  return JSON.stringify(data);
                }
              ]
            })
              .then(res => {
                let data = res.data;
                if (data.success) {
                  this.$message({
                    showClose: true,
                    duration: 1000,
                    message: data.message,
                    type: "success"
                  });
                  // sessionStorage.token = data.data.userInfo.token;
                  sessionStorage.uName = data.data.userInfo.realName;
                  this.$store.state.logName =
                    '<i class="el-icon-s-custom" style="font-size:17px; margin-right: 5px;"></i>' +
                    data.data.userInfo.realName;
                  sessionStorage.setItem(
                    "logMessage",
                    JSON.stringify(data.data.userInfo)
                  );
                  // sessionStorage.setItem("token", data.data.userInfo.token);
                   this.$emit('fatherMethod');
                  this.getMenuData();
                } else {
                  this.$message({
                    showClose: true,
                    duration: 1000,
                    message: data.message,
                    type: "warning"
                  });
                }
              })
              .catch(function(err) {
                console.log(err);
              });
          }
        } else {
          this.$store.state.logName = "登录";
          this.$message({
            showClose: true,
            duration: 1000,
            message: "退出成功",
            type: "success"
          });
          sessionStorage.removeItem("uName");
          sessionStorage.removeItem("logMessage");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("menuItemData");
           this.$emit('fatherMethod');
          this.getMenuData();

          this.dialog.dialogVisible = false;
          // this.judgeLog();
          this.$router.push({
            path: "/"
          });
        }
      }
    },
   compare(property){
        return function(a,b){
            var value1 = a[property];
            var value2 = b[property];
            return value2 - value1;
        }
    },
    setMenu() {
      this.$store.state.isMenuItems = [];
      let itemData = this.$store.state.getMenuItemData;
      let menuItems = this.$store.state.menuItems;
      let headerHtml = "";
      let bannerHtml = "";
      itemData.map(item => {
        if(item.code == '701'){
          if(item.children){
            item.children.sort(this.compare('code'))
          }
        }
      })
      for (const [key, i] of itemData.entries()) {
        for (const m of menuItems) {
          if (i.code == m.index) {
            this.$store.state.isMenuItems.push({
              index: i.code,
              menuName: i.name,
              id: i.id
            });

            bannerHtml = "";

            headerHtml += "<li>";
            bannerHtml +=
              '<div class="banner_nav_B">' +
              '<div class="banner_nav_container">';
            for (const i2 of i.children) {
              for (const m2 of menuItems) {
                if (i2.code == m2.index) {
                  bannerHtml +=
                    "<span class='bannerNavContainer" +
                    m2.name +
                    "' onClick=\"bannerNavClick('" +
                    m2.path +
                    "','" +
                    m2.name +
                    "')\">" +
                    i2.name +
                    "</span>";
                }
              }
            }

            bannerHtml += "</div></div>";
            headerHtml += bannerHtml;
            headerHtml +=
              "<span id='headerContainer" +
              m.index +
              "' class='headerContainer" +
              key +
              "' onClick=\"bannerNavClick('" +
              m.path +
              "')\">" +
              i.name +
              "</span></li>";
          }
        }
      }

      this.header = headerHtml;

      let bannerHtml1 = "";
      let heightFlag = 0;

      for (const [key, i] of itemData.entries()) {
        let divIndex = 0;
        for (const m of menuItems) {
          if (i.code == m.index) {
            if (divIndex == 0) {
              bannerHtml1 += "<div>";
            }
            divIndex++;
            bannerHtml1 +=
              "<span onClick=\"bannerNavClick('" +
              m.path +
              "'," +
              0 +
              ')">' +
              i.name +
              "</span>";

            let item = i.children;
            for (const [key1, x] of item.entries()) {
              for (const y of menuItems) {
                if (x.code == y.index) {
                  heightFlag = key1 > heightFlag ? key1 : heightFlag;
                  bannerHtml1 +=
                    "<span onClick=\"bannerNavClick('" +
                    y.path +
                    "','" +
                    y.name +
                    "')\">" +
                    x.name +
                    "</span>";
                }
              }
            }
          }
        }

        bannerHtml1 += "</div>";
      }

      this.$store.state.bannerNavContainer = bannerHtml1;
      heightFlag = heightFlag - 3;
      $(".footer .footer_nav").css("height", 170 + heightFlag * 27 + "px");
    }
  },
  activated() {
    // window.bannerNavClick = this.bannerNavClick;
    let _this = this;

    let gcWeatherNow = localStorage.getItem("gcWeatherNow");
    let gcWeatherLifestyle = localStorage.getItem("gcWeatherLifestyle");

    if (gcWeatherNow) {
      gcWeatherNow = JSON.parse(gcWeatherNow);
      let a = new Date() - new Date(gcWeatherNow.date);
      if (a > 3600000) {
        getWeatherNow();
      } else {
        setWeatherNowData(gcWeatherNow.data);
      }
    } else {
      getWeatherNow();
    }

    if (gcWeatherLifestyle) {
      gcWeatherLifestyle = JSON.parse(gcWeatherLifestyle);
      let a = new Date() - new Date(gcWeatherNow.date);
      if (a > 3600000) {
        getWeatherLifestyle();
      } else {
        setWeatherLifestyleData(gcWeatherLifestyle.data);
      }
    } else {
      getWeatherLifestyle();
    }

    function setWeatherNowData(data) {
      let date = new Date();
      let wData = data.daily_forecast[0];
      _this.weather.city = data.basic.location;
      _this.weather.week =
        "今天（周" + "日一二三四五六".charAt(date.getDay()) + ")";

      if (date.getHours() > 6 && date.getHours() < 18) {
        _this.weather.img = require("@/assets/images/cond-icon-heweather/" +
          wData.cond_code_d +
          ".png");
      } else {
        _this.weather.img = require("@/assets/images/cond-icon-heweather/" +
          wData.cond_code_n +
          ".png");
      }

      if (wData.cond_txt_d == wData.cond_txt_n) {
        _this.weather.cond = wData.cond_txt_d;
      } else {
        _this.weather.cond = wData.cond_txt_d + "转" + wData.cond_txt_n;
      }

      _this.weather.temperature = wData.tmp_min + "℃ ~ " + wData.tmp_max + "℃";
    }

    function setWeatherLifestyleData(data) {
      let wData = data.lifestyle;
      for (const i of wData) {
        if (i.type == "air") {
          _this.weather.air = i.brf;
        }
      }
    }

    function getWeatherNow() {
      if (!_this.$store.state.weatherLocation) {
        setTimeout(() => {
          getWeatherNow();
        }, 3000);
        return;
      }
      $.ajax({
        url: _this.$store.state.weather.forecast,
        type: "POST",
        dataType: "json",
        data: {
          location: _this.$store.state.weatherLocation,
          key: _this.$store.state.weatherKey
        },
        success: function(data) {
          if (data.HeWeather6[0].status == "ok") {
            localStorage.setItem(
              "gcWeatherNow",
              JSON.stringify({
                date: new Date(),
                data: data.HeWeather6[0]
              })
            );
            setWeatherNowData(data.HeWeather6[0]);
          }
        }
      });
    }
    function getWeatherLifestyle() {
      $.ajax({
        url: _this.$store.state.weather.lifestyle,
        type: "POST",
        dataType: "json",
        data: {
          location: _this.$store.state.weatherLocation,
          key: _this.$store.state.weatherKey
        },
        success: function(data) {
          if (data.HeWeather6[0].status == "ok") {
            localStorage.setItem(
              "gcWeatherLifestyle",
              JSON.stringify({
                date: new Date(),
                data: data.HeWeather6[0]
              })
            );
            setWeatherLifestyleData(data.HeWeather6[0]);
          }
        }
      });
    }

    if (sessionStorage.uName) {
      this.$store.state.logName =
        '<i class="el-icon-s-custom" style="font-size:17px; margin-right: 5px;"></i>' +
        sessionStorage.uName;
    }

    if (sessionStorage.menuItemData) {
      this.$store.state.getMenuItemData = JSON.parse(
        sessionStorage.menuItemData
      );
      this.setMenu();
    } else {
      this.getMenuData();
    }
  }
};
</script>

<style lang="scss">
.header_nav li {
  &.active {
    &:after {
      position: absolute;
      content: "";
      top: 70%;
      left: 50%;
      text-align: center;
      transform: translateX(-50%);
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #139a28;
    }
  }
  & > span {
    padding-bottom: 5px;
    cursor: pointer;
    color: black;
    font-size: 20px;
    font-family: "微软雅黑";
    position: relative;

    &:after {
      position: absolute;
      content: "";
      width: 0%;
      height: 2px;
      top: 28px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #17a900;
      transition: all 0.5s;
      -moz-transition: all 0.5s; /* Firefox 4 */
      -webkit-transition: all 0.5s; /* Safari and Chrome */
      -o-transition: all 0.5s; /* Opera */
    }

    &.active {
      color: #08961f;

      &:after {
        width: 100%;
      }
    }
  }

  &:hover {
    color: #08961f;
    & > span {
      &:after {
        width: 100%;
      }
    }
    .banner_nav_B {
      .banner_nav_container {
        span {
          opacity: 1;
          height: 36px;
          border-bottom: 1px solid white;
        }
        span:last-child {
          border: none;
        }
      }
    }
  }
  .banner_nav_B:hover {
    /*// transform: translateY(0%);*/

    .banner_nav_container {
      span {
        opacity: 1;
        height: 36px;
        border-bottom: 1px solid white;
      }
      span:last-child {
        border: none;
      }
    }
  }
}
.banner_nav_B {
  width: 100%;
  top: 55px;
  /*// box-shadow: 1px 1px 7px 1px #8c8c8c;*/
  position: absolute;
  z-index: 1;
  background-color: #ffffff;

  .banner_nav_container {
    span {
      background-color: #17a900;
      border: none;
      color: #ffffff;
      width: 100%;
      opacity: 0;
      height: 0px;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      font-size: 15px;
      width: 100%;
      display: block;
      padding: 0;
      position: relative;
      transition: all 0.5s;
      -moz-transition: all 0.5s; /* Firefox 4 */
      -webkit-transition: all 0.5s; /* Safari and Chrome */
      -o-transition: all 0.5s; /* Opera */

      &:hover {
        color: #ffffff;
        background-color: #0f7200;
      }
      &.active {
        color: #ffffff;
        background-color: #0f7200;
      }
    }
  }
}

.log_message {
  position: absolute;
  right: 15px;
  top: 33px;
  z-index: 233;
  font-size: 18px;
  cursor: pointer;
  transition: 0.2s linear;
  padding: 5px;
  border: 1px solid;
  border-radius: 5px;
}
.log_message:hover {
  color: #08961f;
}
.login {
  position: absolute;
  right: 25px;
  top: 18px;
  color: #000;
  cursor: pointer;
  border: 1px solid #000;
  border-radius: 5px;
  font-size: 18px;
  .login_btn {
    display: inline-block;
    padding: 2px 13px;
    text-align: center;
    line-height: 30px;
    height: 30px;
  }
  &:hover {
    border-color: #08961f;
    color: #08961f;
  }
}
/*.login_code {
    z-index: 112;
    height: 36px;
    padding: 0 20%;
    background: #f3f7f5;

    span {
      color: #999999;
      line-height: 36px;
    }

    .login_btn {
      margin-left: 50px;
      &:hover {
        text-decoration: underline;
        color: #08961e;
        cursor: pointer;
      }
    }

    .code {
      float: right;
      position: relative;
      cursor: pointer;

      span {
        padding: 0 10px;
        position: relative;

        > img {
          width: 20px;
          top: 4px;
          right: 3px;
          position: relative;
        }

        .code_img {
          width: 120px;
          position: absolute;
          top: 28px;
          left: 50%;
          transform: translateY(20px) translateX(-50%);
          visibility: hidden;
          transition: 0.2s linear;
          z-index: 999999;
          opacity: 0;
        }
        &:hover .code_img {
          visibility: visible;
          transform: translateY(0) translateX(-50%);
          opacity: 1;
        }
      }
    }
  }*/
.header_box .header {
  z-index: 111;
  background: #ffffff;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.header_img {
  float: left;
  height: 100%;
  margin-right: 40px;

  > img {
    height: calc(100% - 30px);
    margin: 15px 0;
    float: left;
  }

  div {
    width: 220px;
    margin: 14px 0 0px 50px;
    color: #08961e;

    > img {
      width: 100%;
      float: left;
    }
  }
}
.header_nav {
  float: left;
  line-height: 68px;
}
.header_weather {
  float: left;
  margin-left: 30px;
  position: relative;

  > div {
    height: 100%;
    float: left;
    margin: 0 5px;
  }

  .header_weather_city {
    width: 100px;
    text-align: center;
    transform: translateY(15%);

    > p:nth-child(1) {
      color: #333333;
      font-size: 16px;
      font-weight: 550;
    }
    > p:nth-child(2) {
      color: #333333;
      font-size: 14px;
    }
  }

  .header_weather_img {
    width: 46px;
    transform: translateY(10%);

    img {
      width: 100%;
    }
  }

  .header_weather_content {
    width: 100px;
    text-align: left;
    transform: translateY(0%);

    > p {
      color: #333333;
      font-size: 13px;
    }
  }
}

.header_nav li {
  text-align: center;
  width: 100px;
  /*// box-sizing: border-box;*/
  float: left;
  /*// transition: all 0.2s;*/
  position: relative;
}
.header_nav li .header_native,
.select_hide .header_native {
  color: #08961f;
}

.header_nav li:before {
  content: "";
  position: absolute;
  top: 43%;
  right: 0;
  height: 15px;
  width: 0px;
  
  /*// background-color: black;*/
}
.header_nav > ul > li:last-child:after,
.header_nav > ul > li:last-child:before {
  height: 0;
}
.header_nav > ul > li > span:hover,
.header_nav > ul > li:hover > span {
  color: #08961f;
}
.hide {
  position: absolute;
  z-index: 2333;
  height: 0;
  left: 0;
  top: 70px;
  background-color: #17a900;
  width: 100%;
  overflow: hidden;
}
.hide,
.hide > div {
  transition: all 0.3s ease-out 0s;
}
.hide > div {
  position: absolute;
  display: block;
  width: 100%;
}

.welcome {
  p {
    padding: 0;
    margin: 0;
    display: inline;
  }
}

@media only screen and (max-width: 1500px) {
  .header_nav li span {
    font-size: 16px;
  }
}

@media only screen and (max-width: 1230px) {
  .header_img {
    div {
      display: none;
    }
  }
}
</style>
<style>
.el-dialog__header {
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
}
.header_box .el-input {
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  z-index: 2333;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
.el-dialog__body {
  padding: 30px 20px 0 20px !important;
  height: 154px;
  flex: 1;
  overflow: auto;
  padding-bottom: 0;
  background: white;
}
.el-dialog__footer {
  text-align: center;
  background: white;
  position: relative;
  top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/headerA.vue